import type { TagProps } from "antd";

export type MovieStatusKey = "released" | "draft" | "archived" | "scheduled" | "disabled" | string;

export const MOVIE_STATUS_META: Record<string, { label: string; color: TagProps["color"] }> = {
  released: { label: "已发布", color: "green" },
  published: { label: "已发布", color: "green" },
  draft: { label: "草稿", color: "default" },
  archived: { label: "已归档", color: "volcano" },
  scheduled: { label: "排期", color: "blue" },
  disabled: { label: "已下线", color: "red" },
};

export const getStatusMeta = (status?: MovieStatusKey | null) => {
  const normalized = (status ?? "").toLowerCase();
  return MOVIE_STATUS_META[normalized] ?? { label: status ?? "未设置", color: "default" };
};
